import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import style from '../ProductPrice.module.scss.js';

const PricePrevious = ({ text, ...otherProps }) => text ? (jsxs(Fragment, { children: [jsx("s", { "aria-hidden": "true", className: style['z-product-price__previous'], ...otherProps, children: text }), ' '] })) : null;
PricePrevious.displayName = 'PricePrevious';

export { PricePrevious };
//# sourceMappingURL=PricePrevious.js.map
